let inDebounce

export function asyncDebounce(func, delay) {
  return async function (...args) {
    const context = this

    clearTimeout(inDebounce)

    return new Promise(resolve => {
      inDebounce = setTimeout(async () => {
        resolve(await func.apply(context, args))
      }, delay)
    })
  }
}
